import { CommandExecutor } from './command-executor';
import { DataLocationFilter } from './../../data-management/data-filters/filters/data-location-filter';
import { Gui } from './../gui';
import * as ol from 'openlayers';

export declare interface SelectLocationCommandInputParameters {
    circleOL: { x: number; y: number; radius: number }; // all in openlayers coordinates for calculations.
    circle: { lat: number; lng: number; kilometers: number }; // understandable coordinates for UI.
    enabled: boolean;
}

export declare interface SelectLocationCommandOutputParameters {
    circleOL: { x: number; y: number; radius: number }; // all in openlayers coordinates for calculations.
    circle: { lat: number; lng: number; kilometers: number }; // understandable coordinates for UI.
    enabled: boolean;
    filter: DataLocationFilter;
}

export class SelectLocationCommandExecutor extends CommandExecutor {
    filter: DataLocationFilter;

    constructor(private gui: Gui) {
        super();
        this.filter = this.gui.app.dataFiltersManager.createLocationFilter();
        // this.requestExecute(this.defaultParameters)
    }

    public requestReset = () => {
        // in this case do nothing since it is the responsability of
        // the gui to throw away the commands it has created!
    }

    public requestExecute = (inputParameters: SelectLocationCommandInputParameters) => {
        if (inputParameters.circleOL === null) {
            let view = this.gui.map.olMap.getView();
            let projection = view.getProjection();
            let resolutionAtEquator = view.getResolution();
            let center = view.getCenter();
            let pointResolution = ol.proj.getPointResolution(projection, resolutionAtEquator, center);
            let resolutionFactor = resolutionAtEquator / pointResolution;
            let radiusOpenlayers =
                ((inputParameters.circle.kilometers * 1000) / ol.proj.METERS_PER_UNIT.m) * resolutionFactor;
            let coordinate = ol.proj.transform(
                [inputParameters.circle.lng, inputParameters.circle.lat],
                'EPSG:4326',
                'EPSG:3857'
            );
            inputParameters.circleOL = {
                x: coordinate[0],
                y: coordinate[1],
                radius: radiusOpenlayers
            };
        }
        if (inputParameters.circle === null) {
            let radius = inputParameters.circleOL.radius;
            let edgeCoordinate: [number, number] = [inputParameters.circleOL.x + radius, inputParameters.circleOL.y];
            let wgs84Sphere = new ol.Sphere(6378137);
            let latlng = ol.proj.transform(
                [inputParameters.circleOL.x, inputParameters.circleOL.y],
                'EPSG:3857',
                'EPSG:4326'
            );
            let groundRadius = wgs84Sphere.haversineDistance(
                latlng,
                ol.proj.transform(edgeCoordinate, 'EPSG:3857', 'EPSG:4326')
            );
            let km: number = groundRadius / 1000.0;
            let roundedkm: number = Math.round(km);
            let lat = latlng[1];
            let lng = latlng[0];
            inputParameters.circle = { lat, lng, kilometers: roundedkm };
        }
        this.filter.execute(inputParameters);

        let outputParameters: SelectLocationCommandOutputParameters = {
            circleOL: inputParameters.circleOL,
            circle: inputParameters.circle,
            enabled: inputParameters.enabled,
            filter: this.filter
        };

        this.notifyExecute(outputParameters);
    }

    public delete = () => {
        this.filter.destroy();
        this.notifyDeleted();
    }
}
